var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6953 45.4043H21.979V46.6828H20.6953V45.4043Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3669 19.8596H37.0908V18.5679H38.3669V19.8596Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9019 19.8581H53.6201V18.5635H54.9019V19.8581Z",
    fill: "#2965FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0674 48.6749V47.3936H36.353V48.6749H35.0674Z",
    fill: "#2965FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17773 18.5571H7.45952V19.8527H6.17773V18.5571Z",
    fill: "#2965FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9848 18.5654V19.8439H20.6992V18.5654H21.9848Z",
    fill: "#2965FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1224 45.4043V46.6837H28.834V45.4043H30.1224Z",
    fill: "#2965FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3626 19.8527H39.0732V18.5742H40.3626V19.8527Z",
    fill: "#2965FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6943 19.8268V18.5806H59.0008V19.8268H57.6943Z",
    fill: "#2965FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39594 19.8527H4.11035V18.5742H5.39594V19.8527Z",
    fill: "#2965FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.29 19.8568V18.5679H11.5813V19.8568H10.29Z",
    fill: "#2965FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48758 18.5742V19.8546H8.19629V18.5742H9.48758Z",
    fill: "#2965FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.8429V18.5635H1.29509V19.8429H0Z",
    fill: "#2965FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5527 47.3765H17.844V48.673H16.5527V47.3765Z",
    fill: "#2965FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8854 48.672H18.6084V47.3765H19.8854V48.672Z",
    fill: "#2965FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.083 45.396H34.3695V46.6925H33.083V45.396Z",
    fill: "#2965FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5596 45.4023H17.8328V46.6903H16.5596V45.4023Z",
    fill: "#2965FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7354 18.561H24.0076V19.8519H22.7354V18.561Z",
    fill: "#2965FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 19.8537V18.5742H30.1099V19.8527L28.8281 19.8537Z",
    fill: "#2965FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8509 19.8543H16.5596V18.5635H17.8509V19.8543Z",
    fill: "#2965FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0423 45.4131V46.6897H24.752V45.4131H26.0423Z",
    fill: "#2965FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01855 19.8458V18.5635H3.31554V19.8458H2.01855Z",
    fill: "#2965FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.918 47.3867H28.2102V48.6586H26.918V47.3867Z",
    fill: "#2965FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8252 48.673V47.3936H30.1117V48.673H28.8252Z",
    fill: "#2965FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2465 48.6702H30.9619V47.3955H32.2465V48.6702Z",
    fill: "#2965FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8434 14.5195V15.8084H51.5654V14.5195H52.8434Z",
    fill: "#2965FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.035 19.8565H24.7646V18.5742H26.035V19.8565Z",
    fill: "#2965FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5654 12.3516H52.8444V13.6414H51.5654V12.3516Z",
    fill: "#2965FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5605 39.1709H52.8309V40.4475H51.5605V39.1709Z",
    fill: "#2965FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5586 22.7607H52.8375V24.0449H51.5586V22.7607Z",
    fill: "#2965FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7383 47.3867H24.02V48.6662H22.7373L22.7383 47.3867Z",
    fill: "#2965FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5605 20.6802H52.8347V21.9568H51.5605V20.6802Z",
    fill: "#2965FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5654 32.6519H52.8453V33.9436H51.5654V32.6519Z",
    fill: "#2965FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8518 16.5444V17.8286H51.5605V16.5444H52.8518Z",
    fill: "#2965FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3601 18.5742V19.8612H35.085V18.5742H36.3601Z",
    fill: "#2965FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8442 38.3245H51.5586V37.0498H52.8442V38.3245Z",
    fill: "#2965FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6123 18.5654H19.8827V19.8458H18.6123V18.5654Z",
    fill: "#2965FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8366 48.6683H51.5586V47.3936H52.8366V48.6683Z",
    fill: "#2965FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 49.5146H21.9765V50.8026H20.71V49.5146Z",
    fill: "#2965FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9837 12.3579V13.6298H20.6953V12.3579H21.9837Z",
    fill: "#2965FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7051 7.49758V6.21436H58.9802V7.49758H57.7051Z",
    fill: "#2965FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6016 15.7946V14.5151H19.8786V15.7946H18.6016Z",
    fill: "#2965FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9764 29.9535H20.7061V28.6655H21.9764V29.9535Z",
    fill: "#2965FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8922 39.188V40.4712H18.6123V39.188H19.8922Z",
    fill: "#2965FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8924 24.06H18.6211V22.7739H19.8924V24.06Z",
    fill: "#2965FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6865 44.6018V43.3433H21.975V44.6018H20.6865Z",
    fill: "#2965FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7393 17.8352V16.5596H26.0296V17.8352H24.7393Z",
    fill: "#2965FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8986 2.12109V3.39294H18.6016V2.12109H19.8986Z",
    fill: "#2965FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9792 30.5562V31.8422H20.7012V30.5562H21.9792Z",
    fill: "#2965FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3896 17.8279V16.5513H13.6629V17.8279H12.3896Z",
    fill: "#2965FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8872 33.9374H18.6016V32.6646H19.89L19.8872 33.9374Z",
    fill: "#2965FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6348 46.627V45.3618H56.9185V46.627H55.6348Z",
    fill: "#2965FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.978 1.29277H20.6953V0.00195312H21.978V1.29277Z",
    fill: "#2965FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9228 6.21191H28.1999V7.50463H26.9219L26.9228 6.21191Z",
    fill: "#2965FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 6.21436H17.8434V7.49095H16.5664V6.21436Z",
    fill: "#2965FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8952 4.17822V5.45482H18.6172V4.17822H19.8952Z",
    fill: "#2965FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6191 20.6763H19.8933V21.9652H18.6191V20.6763Z",
    fill: "#2965FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6191 12.3516H19.8933V13.6424H18.6191V12.3516Z",
    fill: "#2965FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6016 36.0232V34.7476H19.8909V36.0232H18.6016Z",
    fill: "#2965FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6104 30.5498H19.8902V31.8416H18.6104V30.5498Z",
    fill: "#2965FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5635 34.7344H52.8415V36.0252H51.5635V34.7344Z",
    fill: "#2965FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0791 51.5459H40.3618V52.8405H39.0791V51.5459Z",
    fill: "#2965FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1748 51.5522H42.4537V52.8269H41.1729L41.1748 51.5522Z",
    fill: "#2965FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5306 51.542H52.8409V52.8632C52.4713 52.8632 52.1292 52.8802 51.7957 52.8518C51.7376 52.8362 51.6844 52.8062 51.641 52.7646C51.5977 52.723 51.5656 52.6711 51.5477 52.6137C51.5135 52.2751 51.5306 51.9327 51.5306 51.542Z",
    fill: "#2965FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6328 51.5483H56.9108V52.8335H55.6328V51.5483Z",
    fill: "#2965FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7021 51.5459H58.9858V52.8386H57.7031L57.7021 51.5459Z",
    fill: "#2965FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9774 38.3962H20.708V37.1206H21.9774V38.3962Z",
    fill: "#2965FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 53.6138H19.8849V54.898H18.625V53.6138Z",
    fill: "#2965FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8893 57.0098H18.6123V55.7285H19.8893V57.0098Z",
    fill: "#2965FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3649 7.5031H33.0869V6.22461H34.3649V7.5031Z",
    fill: "#2965FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3551 7.5031H37.0752V6.22461H38.3551V7.5031Z",
    fill: "#2965FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4459 7.50215H41.166V6.22461H42.4459V7.50215Z",
    fill: "#2965FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2529 6.20996H46.5205V7.50173H45.2529V6.20996Z",
    fill: "#2965FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3652 6.21436H50.6375V7.50897H49.3652V6.21436Z",
    fill: "#2965FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8912 6.21826V7.49106H53.6094V6.21826H54.8912Z",
    fill: "#2965FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6221 7.4999V6.229H56.9134V7.4999H55.6221Z",
    fill: "#2965FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7285 9.56393V8.29492H24.0198V9.56393H22.7285Z",
    fill: "#2965FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1945 9.58519H26.9346V8.29248H28.1945V9.58519Z",
    fill: "#2965FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0723 9.56332V8.29053H36.3455V9.56332H35.0723Z",
    fill: "#2965FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3678 8.29533V9.56243H37.0889V8.29248L38.3678 8.29533Z",
    fill: "#2965FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3572 9.58041H39.084V8.30762H40.3572V9.58041Z",
    fill: "#2965FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8519 10.3604V11.6208H16.5635V10.3604H17.8519Z",
    fill: "#2965FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9287 10.3457H28.201V11.6204H26.9297L26.9287 10.3457Z",
    fill: "#2965FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1252 10.3604V11.6218H28.832V10.3604H30.1252Z",
    fill: "#2965FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2553 10.3433V11.618H30.9678V10.3433H32.2553Z",
    fill: "#2965FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3685 10.3604V11.6237H37.0781V10.3604H38.3685Z",
    fill: "#2965FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6035 11.6269V10.356H54.8853V11.6269H53.6035Z",
    fill: "#2965FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6328 11.6198V10.3433H56.9089V11.6198H55.6328Z",
    fill: "#2965FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6943 11.6208V10.3604H58.9875V11.6208H57.6943Z",
    fill: "#2965FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2086 12.3623V13.6285H26.9307V12.3623H28.2086Z",
    fill: "#2965FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 13.6425V12.3706H30.1128V13.6425H28.8281Z",
    fill: "#2965FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0869 12.3535H34.364V13.6424H33.0869V12.3535Z",
    fill: "#2965FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3505 13.6487H37.082V12.3579H38.3505V13.6487Z",
    fill: "#2965FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3535 13.6487H39.0859V12.3579H40.3535V13.6487Z",
    fill: "#2965FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5986 13.627V12.3599H54.8909V13.627H53.5986Z",
    fill: "#2965FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9733 15.8002H20.6953V14.5303H21.9714L21.9733 15.8002Z",
    fill: "#2965FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7285 15.7867V14.5215H24.0208V15.7867H22.7285Z",
    fill: "#2965FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24.748 15.7895V14.5215H26.0374V15.7895H24.748Z",
    fill: "#2965FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2059 15.8005H26.9346V14.5239H28.2059V15.8005Z",
    fill: "#2965FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M30.116 15.7996H28.8428V14.5259H30.116V15.7996Z",
    fill: "#2965FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2553 15.8046H30.9707V14.5176H32.2553V15.8046Z",
    fill: "#2965FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0869 15.7964V14.5303H34.3649V15.7964H33.0869Z",
    fill: "#2965FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3571 15.8057H35.0801V14.5215H36.3571V15.8057Z",
    fill: "#2965FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0908 14.5151H38.3678V15.7879H37.0937L37.0908 14.5151Z",
    fill: "#2965FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6074 14.5151H54.8797V15.7927H53.6074V14.5151Z",
    fill: "#2965FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9918 14.5215V15.7895H57.7129V14.5215H58.9918Z",
    fill: "#2965FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28426 17.8466H0.0214844V16.5596H1.28426V17.8466Z",
    fill: "#2965FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02539 17.8245V16.5488H3.29672V17.8245H2.02539Z",
    fill: "#2965FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19629 17.825V16.5513H9.46667V17.825H8.19629Z",
    fill: "#2965FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5808 16.5532V17.8213H10.3047V16.5532H11.5808Z",
    fill: "#2965FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8426 17.8356H16.5723V16.5552H17.8426V17.8356Z",
    fill: "#2965FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0199 16.5576V17.8333H22.7314V16.5576H24.0199Z",
    fill: "#2965FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2103 16.5576V17.8323H26.9199V16.5576H28.2103Z",
    fill: "#2965FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0889 17.8305V16.5596H34.3631V17.8305H33.0889Z",
    fill: "#2965FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3714 16.564V17.832H39.0811V16.564H40.3714Z",
    fill: "#2965FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5986 17.8222V16.5513H54.8909V17.8222H53.5986Z",
    fill: "#2965FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7177 16.5469H58.9852V17.8377H57.7148L57.7177 16.5469Z",
    fill: "#2965FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20898 20.6675H9.46986V21.9555H8.20898V20.6675Z",
    fill: "#2965FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5817 20.6826V21.9516H10.3027V20.6826H11.5817Z",
    fill: "#2965FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6764 20.6846V21.9517H12.3984V20.6846H13.6764Z",
    fill: "#2965FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5596 20.6763H17.8442V21.9623H16.5596V20.6763Z",
    fill: "#2965FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0261 21.9661H24.752V20.6763H26.0261V21.9661Z",
    fill: "#2965FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9111 21.9476V20.6929H28.1996V21.9476H26.9111Z",
    fill: "#2965FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3594 21.97H33.0938V20.6802H34.3594V21.97Z",
    fill: "#2965FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3581 21.9677H35.0801V20.6826H36.3581V21.9677Z",
    fill: "#2965FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4584 20.6953V21.9567H41.1709V20.6953H42.4584Z",
    fill: "#2965FF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5272 21.9691H43.2559V20.6782H44.5272V21.9691Z",
    fill: "#2965FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6366 21.9656H49.3652V20.689H50.6366V21.9656Z",
    fill: "#2965FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7129 20.6802H58.9918V21.9539H57.7129V20.6802Z",
    fill: "#2965FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11621 22.7607H5.39515V24.044H4.11621V22.7607Z",
    fill: "#2965FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17773 24.0404V22.7695H7.46523V24.0404H6.17773Z",
    fill: "#2965FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48668 22.7778V24.0449H8.19824V22.7778H9.48668Z",
    fill: "#2965FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 22.7632H11.5789V24.0512H10.3047V22.7632Z",
    fill: "#2965FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7534 24.0528H14.4688V22.7695H15.7534V24.0528Z",
    fill: "#2965FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24.003 24.0566H22.7393V22.7695H24.003V24.0566Z",
    fill: "#2965FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2049 22.7822V24.0541H26.9307V22.7822H28.2049Z",
    fill: "#2965FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M32.221 24.0521H30.9658V22.7803H32.221V24.0521Z",
    fill: "#2965FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0869 22.7588H36.3535V24.0487H35.0869V22.7588Z",
    fill: "#2965FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0879 22.7671H40.3668V24.0389H39.0879V22.7671Z",
    fill: "#2965FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5433 22.7822V24.0436H43.2539V22.7822H44.5433Z",
    fill: "#2965FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6051 24.0537H47.3271V22.7695H48.6051V24.0537Z",
    fill: "#2965FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6367 24.0445V22.7632H56.9128V24.0445H55.6367Z",
    fill: "#2965FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27922 25.9418H0.0107422V24.6558H1.27922V25.9418Z",
    fill: "#2965FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29404 25.9433H2.03125V24.6582H3.29404V25.9433Z",
    fill: "#2965FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40299 25.9434H4.125V24.6602H5.40299V25.9434Z",
    fill: "#2965FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45144 25.9491H6.19531V24.6602H7.45144V25.9491Z",
    fill: "#2965FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48216 25.9443H8.20703V24.6582H9.48216V25.9443Z",
    fill: "#2965FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M11.573 25.9399H10.2969V24.6709H11.573V25.9399Z",
    fill: "#2965FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5684 24.6558H17.8435V25.9276H16.5684V24.6558Z",
    fill: "#2965FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8833 25.9394H18.6016V24.6685H19.8814L19.8833 25.9394Z",
    fill: "#2965FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9718 25.9522H20.71V24.6709H21.9718V25.9522Z",
    fill: "#2965FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M24.002 25.9452H22.7393V24.6582H24.002V25.9452Z",
    fill: "#2965FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0328 25.9403H24.7539V24.6685H26.0328V25.9403Z",
    fill: "#2965FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30.115 25.9406H28.8408V24.6621H30.115V25.9406Z",
    fill: "#2965FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0742 25.9337V24.6685H36.3532V25.9337H35.0742Z",
    fill: "#2965FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0713 25.9415V24.6621H38.3673V25.9415H37.0713Z",
    fill: "#2965FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3554 25.9433H39.0859V24.6753H40.3554V25.9433Z",
    fill: "#2965FF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6006 25.9272V24.6582H54.8928V25.9272H53.6006Z",
    fill: "#2965FF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9869 25.9375H57.7051V24.6685H58.9869V25.9375Z",
    fill: "#2965FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17383 27.8561V26.5767H7.46036V27.8561H6.17383Z",
    fill: "#2965FF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47345 27.8596H8.20117V26.5679H9.47345V27.8596Z",
    fill: "#2965FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5781 27.8675H10.3096V26.5767H11.5781V27.8675Z",
    fill: "#2965FF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7362 27.8616H14.4639V26.5698H15.7362V27.8616Z",
    fill: "#2965FF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 26.5552H17.832V27.846H16.5664V26.5552Z",
    fill: "#2965FF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0247 26.583V27.8482H22.7354V26.583H24.0247Z",
    fill: "#2965FF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M24.748 27.8432V26.5723H26.0393V27.8432H24.748Z",
    fill: "#2965FF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9746 26.5659H32.2526V27.8586H30.9746V26.5659Z",
    fill: "#2965FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3557 27.8694H33.0977V26.5767H34.3557V27.8694Z",
    fill: "#2965FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M39.084 26.5659H40.3629V27.8482H39.0887L39.084 26.5659Z",
    fill: "#2965FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4537 26.5723V27.8451H41.1729V26.5723H42.4537Z",
    fill: "#2965FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5972 27.8552H47.3145V26.5786H48.5972V27.8552Z",
    fill: "#2965FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6231 27.8621H49.3584V26.5723H50.6231V27.8621Z",
    fill: "#2965FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9119 27.8625H55.6367V26.5698H56.9119V27.8625Z",
    fill: "#2965FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02539 28.6528H3.30527V29.9323H2.02539V28.6528Z",
    fill: "#2965FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12695 28.6528H5.39543V29.9408H4.12695V28.6528Z",
    fill: "#2965FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18652 28.6528H7.45786V29.919H6.18652V28.6528Z",
    fill: "#2965FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48325 28.6636V29.9411H8.21191V28.6636H9.48325Z",
    fill: "#2965FF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6629 29.9399H12.3916V28.6719H13.6629V29.9399Z",
    fill: "#2965FF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8509 28.6699V29.9361H16.5596V28.6699H17.8509Z",
    fill: "#2965FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0501 28.6699V29.9285H24.7588V28.6699H26.0501Z",
    fill: "#2965FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8428 28.6509H30.116V29.9369H28.8428V28.6509Z",
    fill: "#2965FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0869 28.6509H34.3649V29.9341H33.0869V28.6509Z",
    fill: "#2965FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3762 28.6719V29.9276H37.084V28.6719H38.3762Z",
    fill: "#2965FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1729 28.6572H42.4404V29.9291H41.1729V28.6572Z",
    fill: "#2965FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5271 29.9396H45.251V28.6592H46.5271V29.9396Z",
    fill: "#2965FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6412 28.6592V29.9272H49.3613V28.6592H50.6412Z",
    fill: "#2965FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8987 28.6719V29.9266H53.6074V28.6719H54.8987Z",
    fill: "#2965FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0166016 30.5454H1.28604V31.8362H0.0166016V30.5454Z",
    fill: "#2965FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30449 31.838H2.03125V30.5586H3.30449V31.838Z",
    fill: "#2965FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39628 31.8356H4.12305V30.5562H5.39628V31.8356Z",
    fill: "#2965FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46438 31.8362H6.18164V30.5625H7.46438V31.8362Z",
    fill: "#2965FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48317 30.5542V31.8232H8.20898V30.5542H9.48317Z",
    fill: "#2965FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3008 30.5522H11.5721V31.8288H10.3008V30.5522Z",
    fill: "#2965FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5576 31.8352V30.5586H17.8451V31.8352H16.5576Z",
    fill: "#2965FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7354 30.5522H24.0038V31.8317H22.7354V30.5522Z",
    fill: "#2965FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 30.5435H26.0299V31.8333H24.75V30.5435Z",
    fill: "#2965FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1224 30.5522V31.8307H28.832V30.5522H30.1224Z",
    fill: "#2965FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M35.085 30.5479H36.3563V31.8207H35.085V30.5479Z",
    fill: "#2965FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M37.082 30.5352H38.3496V31.8269H37.082V30.5352Z",
    fill: "#2965FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M39.084 30.5479H40.3629V31.832H39.0878L39.084 30.5479Z",
    fill: "#2965FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6201 30.5371H54.8791V31.8279H53.6201V30.5371Z",
    fill: "#2965FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9993 30.5625V31.8325H57.707V30.5625H58.9993Z",
    fill: "#2965FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18555 33.938V32.6709H9.47398V33.938H8.18555Z",
    fill: "#2965FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5787 33.9388H10.2969V32.667H11.5787V33.9388Z",
    fill: "#2965FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3984 32.6411H13.6631V33.9281H12.3984V32.6411Z",
    fill: "#2965FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8435 33.9376H16.5703V32.6582H17.8435V33.9376Z",
    fill: "#2965FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0358 33.9376H24.7588V32.6562H26.0358V33.9376Z",
    fill: "#2965FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9218 32.6475H28.2007V33.9364H26.918L26.9218 32.6475Z",
    fill: "#2965FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3765 32.6582V33.9291H33.0957V32.6582H34.3765Z",
    fill: "#2965FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0801 32.6519H36.3571V33.9247H35.0801V32.6519Z",
    fill: "#2965FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1748 32.6538H42.4528V33.9266H41.1758L41.1748 32.6538Z",
    fill: "#2965FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2559 32.6538H44.5272V33.9323H43.2559V32.6538Z",
    fill: "#2965FF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3573 32.6538H50.6249V33.938H49.3545L49.3573 32.6538Z",
    fill: "#2965FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9973 32.667V33.9379H57.7051V32.667H58.9973Z",
    fill: "#2965FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11426 36.015V34.7412H5.38844V36.015H4.11426Z",
    fill: "#2965FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46812 34.7539V36.0258H6.17969V34.7577L7.46812 34.7539Z",
    fill: "#2965FF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20508 34.7261H9.46786V36.0122H8.20508V34.7261Z",
    fill: "#2965FF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2938 34.7344H11.5728V36.0242H10.29L10.2938 34.7344Z",
    fill: "#2965FF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7648 34.7451V36.0103H14.4707V34.7451H15.7648Z",
    fill: "#2965FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5684 0.00195312H17.8435V1.2738H16.5684V0.00195312Z",
    fill: "#2965FF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M24.02 34.7412V36.014H22.7373V34.7412H24.02Z",
    fill: "#2965FF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 34.7261H28.2003V36.015H26.9413L26.9375 34.7261Z",
    fill: "#2965FF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2507 36.0246H30.9766V34.7451H32.2507V36.0246Z",
    fill: "#2965FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0674 36.0132V34.7451H36.3587V36.0132H35.0674Z",
    fill: "#2965FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0791 36.016V34.7451H40.3533V36.016H39.0791Z",
    fill: "#2965FF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5436 34.7451V36.0141H43.2637V34.7451H44.5436Z",
    fill: "#2965FF"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6086 34.7515V36.0243H47.3164V34.7543L48.6086 34.7515Z",
    fill: "#2965FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6016 0.00830078H19.8872V1.2811H18.6016V0.00830078Z",
    fill: "#2965FF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6387 34.728H56.9062V36.0151H55.6387V34.728Z",
    fill: "#2965FF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0752 38.3147V37.0391H38.3494V38.3147H37.0752Z",
    fill: "#2965FF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3669 37.0435V38.3077H39.0898V37.0435H40.3669Z",
    fill: "#2965FF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4524 37.0459V38.3187H41.1621V37.0459H42.4524Z",
    fill: "#2965FF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2451 38.3087V37.0435H44.5364V38.3087H43.2451Z",
    fill: "#2965FF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5925 38.327H47.3184V37.0391H48.5925V38.327Z",
    fill: "#2965FF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0208 0.0214844V1.28575H22.7314V0.0214844H24.0208Z",
    fill: "#2965FF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6328 38.3144V37.0435H56.906V38.3144H55.6328Z",
    fill: "#2965FF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9975 37.0391V38.3147H57.7109V37.0391H58.9975Z",
    fill: "#2965FF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39628 38.3947H4.12305V37.1162H5.39628V38.3947Z",
    fill: "#2965FF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16699 38.3808V37.127H7.45448V38.3808H6.16699Z",
    fill: "#2965FF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3027 37.1011H11.5674V38.3881H10.3027V37.1011Z",
    fill: "#2965FF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6755 37.1206V38.3858H12.4004V37.1206H13.6755Z",
    fill: "#2965FF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M15.744 38.3954H14.4727V37.1226H15.744V38.3954Z",
    fill: "#2965FF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9199 1.2773V0.00830078H28.2112V1.2773H26.9199Z",
    fill: "#2965FF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7285 38.3953V37.1206H24.0113V38.3953H22.7285Z",
    fill: "#2965FF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1213 37.1245V38.3954H28.8281V37.1245H30.1213Z",
    fill: "#2965FF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3734 37.1206V38.382H35.085V37.1206H36.3734Z",
    fill: "#2965FF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28983 40.4693H0.0166016V39.188H1.28983V40.4693Z",
    fill: "#2965FF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02539 39.1797H3.30527V40.4639H2.02539V39.1797Z",
    fill: "#2965FF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39449 40.468H4.12695V39.1904H5.39449V40.468Z",
    fill: "#2965FF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46635 39.1841V40.4559H6.18457V39.1841H7.46635Z",
    fill: "#2965FF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4658 39.1816H15.7372V40.4582H14.4658V39.1816Z",
    fill: "#2965FF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M30.116 1.28983H28.8428V0.0151367H30.116V1.28983Z",
    fill: "#2965FF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7314 40.4661V39.1924H24.0132V40.4661H22.7314Z",
    fill: "#2965FF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9619 40.4589V39.188H32.2561V40.4589H30.9619Z",
    fill: "#2965FF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0977 39.1777H34.3756V40.4686H33.1014L33.0977 39.1777Z",
    fill: "#2965FF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0928 39.1646H38.3575V40.4525H37.0928V39.1646Z",
    fill: "#2965FF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0752 40.4563V39.1797H40.3617V40.4563H39.0752Z",
    fill: "#2965FF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5369 39.1797V40.4553H43.2637V39.1797H44.5369Z",
    fill: "#2965FF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2422 39.167H46.5192V40.4512H45.2422V39.167Z",
    fill: "#2965FF"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3105 40.4439V39.1777H48.6018V40.4439H47.3105Z",
    fill: "#2965FF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2466 1.28989H30.9639V0.0170898H32.2466V1.28989Z",
    fill: "#2965FF"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6035 39.167H54.8824V40.4521H53.6035V39.167Z",
    fill: "#2965FF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9178 40.4544H55.6455V39.1816H56.9178V40.4544Z",
    fill: "#2965FF"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0801 41.2007H38.3505V42.4792H37.0801V41.2007Z",
    fill: "#2965FF"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0947 41.1982H40.3623V42.4872H39.0957L39.0947 41.1982Z",
    fill: "#2965FF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6234 42.4985H49.3691V41.2114H50.6234V42.4985Z",
    fill: "#2965FF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9793 42.4871H57.7051V41.2134H58.9793V42.4871Z",
    fill: "#2965FF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 42.5502V41.2793H1.28482V42.5502H0.00683594Z",
    fill: "#2965FF"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02539 42.5456V41.269H3.29768V42.5456H2.02539Z",
    fill: "#2965FF"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12305 41.2559H5.38773V42.5438H4.12305V41.2559Z",
    fill: "#2965FF"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46546 42.5599H6.18652V41.271H7.46546V42.5599Z",
    fill: "#2965FF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M11.577 42.5548H10.3047V41.2754H11.577V42.5548Z",
    fill: "#2965FF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6783 41.2729V42.5439H12.3984V41.2729H13.6783Z",
    fill: "#2965FF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9733 42.5545H20.6953V41.2817H21.9723L21.9733 42.5545Z",
    fill: "#2965FF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9199 42.552V41.2773H28.2065V42.552H26.9199Z",
    fill: "#2965FF"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1224 41.269V42.5456H28.834V41.269H30.1224Z",
    fill: "#2965FF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0889 41.2646H34.3631V42.5479H33.0889V41.2646Z",
    fill: "#2965FF"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3621 44.5509H37.0889V43.2725H38.3621V44.5509Z",
    fill: "#2965FF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0811 43.2598H40.3619V44.5449H39.0839L39.0811 43.2598Z",
    fill: "#2965FF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5962 44.5506H47.3145V43.2749H48.5962V44.5506Z",
    fill: "#2965FF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8781 44.5604H53.6201V43.2705H54.8781V44.5604Z",
    fill: "#2965FF"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9785 44.5594H57.7109V43.2686H58.9785V44.5594Z",
    fill: "#2965FF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0693 1.28793V0.0151367H36.354V1.28793H35.0693Z",
    fill: "#2965FF"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0209 43.3325V44.611H22.7354V43.3325H24.0209Z",
    fill: "#2965FF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1991 44.6206H26.9307V43.3345H28.1991V44.6206Z",
    fill: "#2965FF"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1235 43.3364V44.6064H28.8389V43.3364H30.1235Z",
    fill: "#2965FF"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2516 44.6221H30.9746V43.3389H32.2516V44.6221Z",
    fill: "#2965FF"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3768 43.3452V44.619H33.1045V43.3452H34.3768Z",
    fill: "#2965FF"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0674 44.6013V43.3408H36.3568V44.6013H35.0674Z",
    fill: "#2965FF"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0752 1.28194V0.00439453H38.3513V1.28194H37.0752Z",
    fill: "#2965FF"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0879 0.00634766H40.3554V1.28199H39.0879V0.00634766Z",
    fill: "#2965FF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M41.166 0.00195312H42.4431V1.28518H41.166V0.00195312Z",
    fill: "#2965FF"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2686 0H44.5313V1.28607H43.2686V0Z",
    fill: "#2965FF"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5261 1.29208H45.251V0.0107422H46.5261V1.29208Z",
    fill: "#2965FF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6231 1.29532H49.3584V0.00830078H50.6231V1.29532Z",
    fill: "#2965FF"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2539 45.3447H44.53V46.6251H43.2539V45.3447Z",
    fill: "#2965FF"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6096 45.3574V46.6236H47.3164V45.3574H48.6096Z",
    fill: "#2965FF"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8997 0.0170898V1.28514H53.6074V0.0170898H54.8997Z",
    fill: "#2965FF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M57.709 45.3447H58.986V46.6251H57.7128L57.709 45.3447Z",
    fill: "#2965FF"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6367 1.28572V0.00439453H56.9137V1.28572H55.6367Z",
    fill: "#2965FF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8578 2.12549V3.3869H16.5703V2.12549H17.8578Z",
    fill: "#2965FF"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7314 2.11035H24.0113V3.39643H22.7314V2.11035Z",
    fill: "#2965FF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7539 2.11475H26.0262V3.39798H24.7539V2.11475Z",
    fill: "#2965FF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9219 3.39858V2.11914H28.1999V3.39858H26.9219Z",
    fill: "#2965FF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9785 2.11035H32.2489V3.39643H30.9785V2.11035Z",
    fill: "#2965FF"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3767 3.40487H33.1025V2.12354H34.3767V3.40487Z",
    fill: "#2965FF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0723 2.11475H36.3503V3.39892H35.0723V2.11475Z",
    fill: "#2965FF"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3611 48.6689H37.0859V47.3828H38.3611V48.6689Z",
    fill: "#2965FF"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6069 47.3784V48.656H47.3203V47.3784H48.6069Z",
    fill: "#2965FF"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3611 3.40397H39.0879V2.12549H40.3611V3.40397Z",
    fill: "#2965FF"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M57.707 48.6601V47.3911H58.985V48.6601H57.707Z",
    fill: "#2965FF"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3184 2.11475H48.5925V3.39798H47.3184V2.11475Z",
    fill: "#2965FF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M40.363 50.6957H39.0859V49.4248H40.363V50.6957Z",
    fill: "#2965FF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4529 49.4204V50.6932H41.1797V49.4204H42.4529Z",
    fill: "#2965FF"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6051 49.4121V50.683H47.3252V49.4121H48.6051Z",
    fill: "#2965FF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6338 50.6932H49.3691V49.4204H50.6338V50.6932Z",
    fill: "#2965FF"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8886 50.6932H53.6201V49.4185H54.8886V50.6932Z",
    fill: "#2965FF"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7167 49.4077H58.9852V50.6976H57.7129L57.7167 49.4077Z",
    fill: "#2965FF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8339 50.8075H16.5635V49.5186H17.8339V50.8075Z",
    fill: "#2965FF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8968 49.5186V50.7885H18.6084V49.5186H19.8968Z",
    fill: "#2965FF"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6035 2.11035H54.8843V3.39643H53.6035V2.11035Z",
    fill: "#2965FF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0108 50.8192H22.748V49.5293H24.0108V50.8192Z",
    fill: "#2965FF"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0299 50.8036H24.752V49.5317H26.0299V50.8036Z",
    fill: "#2965FF"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2008 50.8026H26.9199V49.5317H28.2008V50.8026Z",
    fill: "#2965FF"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1109 50.8026H28.8301V49.5317H30.1109V50.8026Z",
    fill: "#2965FF"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9766 49.5122H32.2498V50.803H30.9766V49.5122Z",
    fill: "#2965FF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0996 49.5122H34.3691V50.8021H33.0996V49.5122Z",
    fill: "#2965FF"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3609 50.8065H35.0781V49.5186H36.3609V50.8065Z",
    fill: "#2965FF"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8862 52.8168H18.6016V51.5459H19.889L19.8862 52.8168Z",
    fill: "#2965FF"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0194 52.8114H24.748V51.5396H26.0194V52.8114Z",
    fill: "#2965FF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9287 51.5396H28.1934V52.8114H26.9287V51.5396Z",
    fill: "#2965FF"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2562 51.5351V52.8117H30.9678V51.5332L32.2562 51.5351Z",
    fill: "#2965FF"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0693 52.8196V51.5459H36.353V52.8196H35.0693Z",
    fill: "#2965FF"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6328 2.11035H56.9136V3.39643H55.6328V2.11035Z",
    fill: "#2965FF"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7051 2.11035H58.9878V3.39643H57.7051V2.11035Z",
    fill: "#2965FF"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2559 51.5522H44.5434V52.8288H43.2578L43.2559 51.5522Z",
    fill: "#2965FF"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5291 51.5781V52.8329H45.2549V51.5781H46.5291Z",
    fill: "#2965FF"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6231 52.844H49.3584V51.5503H50.6231V52.844Z",
    fill: "#2965FF"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5576 5.44468V4.17188H17.8318V5.44468H16.5576Z",
    fill: "#2965FF"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8902 51.5522V52.825H53.6094V51.5522H54.8902Z",
    fill: "#2965FF"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 5.44568V4.17383H30.1004V5.44568H28.8281Z",
    fill: "#2965FF"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0781 5.45161V4.18262H38.3561V5.45161H37.0781Z",
    fill: "#2965FF"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5192 5.45636H45.2402V4.18262H46.5192V5.45636Z",
    fill: "#2965FF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9998 5.45665H51.7256V4.17627H52.9998V5.45665Z",
    fill: "#2965FF"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0104 54.8993H22.7314V53.6265H24.0104V54.8993Z",
    fill: "#2965FF"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9092 54.898V53.6309H28.2005V54.898H26.9092Z",
    fill: "#2965FF"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8428 53.6138H30.117V54.8989H28.8428V53.6138Z",
    fill: "#2965FF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9551 54.8986V53.6201H32.2464V54.8986H30.9551Z",
    fill: "#2965FF"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0938 53.603H34.3575V54.8901H33.0938V53.603Z",
    fill: "#2965FF"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0801 53.6162H36.36V54.889H35.0801V53.6162Z",
    fill: "#2965FF"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3667 53.603V54.8739H37.084V53.603H38.3667Z",
    fill: "#2965FF"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0947 53.6011H40.3708V54.8739H39.0947V53.6011Z",
    fill: "#2965FF"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5427 53.6094V54.8831H43.2686V53.6094H44.5427Z",
    fill: "#2965FF"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2227 54.8704V53.6138H46.5168V54.8704H45.2227Z",
    fill: "#2965FF"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3252 53.6011H48.6022V54.8729H47.3252V53.6011Z",
    fill: "#2965FF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6201 53.5947H54.8867V54.8836H53.6201V53.5947Z",
    fill: "#2965FF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M37.084 55.605H38.3677V56.8787H37.0859L37.084 55.605Z",
    fill: "#2965FF"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3812 55.6113V56.8737H39.0918V55.6113H40.3812Z",
    fill: "#2965FF"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4472 56.8914H41.1797V55.6177H42.4472V56.8914Z",
    fill: "#2965FF"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5369 55.6113V56.8775H43.2617V55.6113H44.5369Z",
    fill: "#2965FF"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2461 55.5918H46.5136V56.8807H45.2461V55.5918Z",
    fill: "#2965FF"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3545 56.8905V55.6196H50.6249V56.8905H49.3545Z",
    fill: "#2965FF"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6367 55.6025H56.9119V56.882H55.6367V55.6025Z",
    fill: "#2965FF"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7109 55.605H58.9804V56.8835H57.7109V55.605Z",
    fill: "#2965FF"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8425 57.0127H16.5664V55.7285H17.8425V57.0127Z",
    fill: "#2965FF"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8789 7.51193H18.6123V6.21826H19.8789V7.51193Z",
    fill: "#2965FF"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7393 55.7266H24.0201V56.9994H22.7393V55.7266Z",
    fill: "#2965FF"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0957 55.7222H34.3746V56.994H33.1004L33.0957 55.7222Z",
    fill: "#2965FF"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5576 58.9818V57.709H17.8432V58.9818H16.5576Z",
    fill: "#2965FF"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7012 57.7002H21.9687V58.9768H20.7012V57.7002Z",
    fill: "#2965FF"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M28.222 57.7046V58.9641H26.9346V57.7046H28.222Z",
    fill: "#2965FF"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M30.114 58.9847H28.8389V57.7109H30.114V58.9847Z",
    fill: "#2965FF"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0869 58.9768V57.7002H34.3601V58.9768H33.0869Z",
    fill: "#2965FF"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M36.359 58.9878H35.0801V57.7026H36.359V58.9878Z",
    fill: "#2965FF"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3602 58.9996H37.0889V57.7173H38.3602V58.9996Z",
    fill: "#2965FF"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0791 58.9871V57.7134H40.3704V58.9871H39.0791Z",
    fill: "#2965FF"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M45.249 57.7109H46.5261V58.9847H45.249V57.7109Z",
    fill: "#2965FF"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M48.606 57.7134V58.9862H47.3232V57.7134H48.606Z",
    fill: "#2965FF"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8902 57.7134V58.9852H53.6094V57.7134H54.8902Z",
    fill: "#2965FF"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5916 52.8401H47.3203V51.5483H48.5916V52.8401Z",
    fill: "#2965FF"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3525 38.3168V37.0459H50.64V38.3168H49.3525Z",
    fill: "#2965FF"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3818 47.3804H50.6389V48.6532H49.3818V47.3804Z",
    fill: "#2965FF"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9111 57.0045V55.7393H28.2005V57.0045H26.9111Z",
    fill: "#2965FF"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9063 9.58099H55.6436V8.29492H56.9063V9.58099Z",
    fill: "#2965FF"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9188 16.5576V17.82H55.6475V16.5576H56.9188Z",
    fill: "#2965FF"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6023 6.21436V7.50233H47.3291V6.21436H48.6023Z",
    fill: "#2965FF"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8953 17.8437H18.623V16.5576H19.8953V17.8437Z",
    fill: "#2965FF"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6455 57.7134H56.914V58.9985H55.6455V57.7134Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern3);
export default __webpack_public_path__ + "static/media/pattern3.579d6129585725a27988e7a4c0328667.svg";
export { ForwardRef as ReactComponent };